import React from 'react';
import { Box, Typography, Button, Container, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Lock } from '@mui/icons-material';
import { getDefaultRoute } from '../../utils/routeUtils';
import { ROUTES } from '../../utils/constants';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { role, isAuthenticated, user } = useSelector((state) => state.auth);

  const handleGoHome = () => {
    // If the user is logged in, send them to their default page, otherwise to login.
    const destination = isAuthenticated && role ? getDefaultRoute(role) : ROUTES.LOGIN;
    navigate(destination);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="90vh"
        textAlign="center"
        gap={2}
      >
        <Box
          sx={{
            p: 3,
            bgcolor: 'error.light',
            borderRadius: '50%',
            display: 'inline-flex',
            mb: 2
          }}
        >
          <Lock sx={{ fontSize: '3rem', color: 'white' }} />
        </Box>
        
        <Typography 
          variant="h3" 
          component="h1" 
          fontWeight="bold"
          color="error.main"
        >
          Access Denied
        </Typography>
        
        <Typography 
          variant="h6"
          color="text.secondary"
          sx={{ mb: 2 }}
        >
          You don't have permission to access this page.
        </Typography>

        {isAuthenticated && role && (
          <Alert severity="warning" variant="outlined" sx={{ mb: 2, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>Current Role:</strong> {role}
            </Typography>
             <Typography variant="body2">
              <strong>User:</strong> {user?.email}
            </Typography>
          </Alert>
        )}
        
        <Box display="flex" gap={2} mt={2}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleGoHome}
          >
            {isAuthenticated ? 'Go to My Dashboard' : 'Go to Login'}
          </Button>
          
          <Button 
            variant="outlined" 
            onClick={handleGoBack}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Unauthorized;

// // ====================================
// // src/pages/errors/Unauthorized.jsx
// // ====================================
// import React from 'react';
// import { Box, Typography, Button, Container, Alert } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { Lock } from '@mui/icons-material';
// import { getDefaultRoute, getAccessibleRoutes } from '../../utils/routeUtils';
// import { ROUTES, USER_ROLES } from '../../utils/constants';

// const Unauthorized = () => {
//   const navigate = useNavigate();
//   const { role, isAuthenticated, user } = useSelector((state) => state.auth);

//   const handleGoHome = () => {
//     if (isAuthenticated && role) {
//       const defaultRoute = getDefaultRoute(role);
//       navigate(defaultRoute);
//     } else {
//       navigate(ROUTES.LOGIN);
//     }
//   };

//   const handleGoBack = () => {
//     navigate(-1);
//   };

//   const accessibleRoutes = role ? getAccessibleRoutes(role) : [];
//   const suggestedRoutes = accessibleRoutes.slice(0, 3);

//   const getRoleDisplayName = (roleValue) => {
//     const roleNames = {
//       [USER_ROLES.JOURNALIST]: 'Journalist',
//       [USER_ROLES.STATION_MANAGER]: 'Station Manager',
//       [USER_ROLES.ADMIN]: 'Administrator',
//       [USER_ROLES.INFLUENCER]: 'Influencer',
//       [USER_ROLES.NLA_ADMIN]: 'NLA Administrator',
//     };
//     return roleNames[roleValue] || roleValue;
//   };

//   return (
//     <Container maxWidth="md">
//       <Box
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         minHeight="100vh"
//         textAlign="center"
//         gap={3}
//       >
//         <Box
//           sx={{
//             width: 120,
//             height: 120,
//             borderRadius: '50%',
//             bgcolor: 'error.light',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             mb: 2
//           }}
//         >
//           <Lock sx={{ fontSize: '3rem', color: 'error.contrastText' }} />
//         </Box>
        
//         <Typography 
//           variant="h3" 
//           component="h1" 
//           gutterBottom
//           sx={{ 
//             fontSize: { xs: '2rem', md: '3rem' },
//             fontWeight: 'bold',
//             color: 'error.main'
//           }}
//         >
//           Access Denied
//         </Typography>
        
//         <Typography 
//           variant="h6" 
//           component="h2" 
//           gutterBottom
//           color="text.secondary"
//           sx={{ mb: 3 }}
//         >
//           You don't have permission to access this page
//         </Typography>

//         {isAuthenticated && role && (
//           <Alert severity="info" sx={{ mb: 3, maxWidth: '500px' }}>
//             <Typography variant="body2">
//               <strong>Current Role:</strong> {getRoleDisplayName(role)}
//               <br />
//               <strong>User:</strong> {user?.username || user?.email}
//             </Typography>
//           </Alert>
//         )}
        
//         <Typography 
//           variant="body1" 
//           color="text.secondary"
//           sx={{ 
//             mb: 4,
//             maxWidth: '600px',
//             fontSize: '1rem'
//           }}
//         >
//           {isAuthenticated 
//             ? "Your current role doesn't have the required permissions to view this content. If you believe this is an error, please contact your administrator."
//             : "Please log in to access this content."
//           }
//         </Typography>

//         {suggestedRoutes.length > 0 && (
//           <Box sx={{ mb: 3 }}>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//               You might want to visit:
//             </Typography>
//             <Box display="flex" gap={1} flexWrap="wrap" justifyContent="center">
//               {suggestedRoutes.map((route) => (
//                 <Button
//                   key={route}
//                   variant="text"
//                   size="small"
//                   onClick={() => navigate(route)}
//                 >
//                   {route.replace('/', '').charAt(0).toUpperCase() + route.slice(2)}
//                 </Button>
//               ))}
//             </Box>
//           </Box>
//         )}
        
//         <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
//           <Button 
//             variant="contained" 
//             color="primary" 
//             onClick={handleGoHome}
//             size="large"
//           >
//             {isAuthenticated ? 'Go to Dashboard' : 'Go to Login'}
//           </Button>
          
//           <Button 
//             variant="outlined" 
//             onClick={handleGoBack}
//             size="large"
//           >
//             Go Back
//           </Button>
//         </Box>

//         {!isAuthenticated && (
//           <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
//             Need an account? Contact your administrator for access.
//           </Typography>
//         )}
//       </Box>
//     </Container>
//   );
// };

// export default Unauthorized;
